// import React, { useEffect, useState } from "react";
// import axios from "axios";

// export default function Gallery() {
//   const [gallery, setGallery] = useState([]);
//   const [preview, setPreview] = useState(null); // For popup view

//   useEffect(() => {
//     axios.get("https://luckydraw.hoppersdome.com/api/gallery/all")
//       .then(res => setGallery(res.data));
//   }, []);

//   return (
//     <div className="p-4 md:p-10">
//       <h2 className="text-3xl font-bold mb-6 text-center">Our Gallery</h2>

//       {/* GALLERY GRID */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//         {gallery.map((g) => (
//           <div
//             key={g.id}
//             className="rounded-xl overflow-hidden shadow-lg bg-white"
//           >
           

//             {/* IMAGE BLOCK */}
//             <div className="relative group cursor-pointer">
//               <img
//                 src={`https://luckydraw.hoppersdome.com/uploads/gallery/${g.image}`}
//                 alt=""
//                 className="w-full h-40 md:h-48 object-cover transition-transform duration-300 group-hover:scale-110"
//                 onClick={() => setPreview(`https://luckydraw.hoppersdome.com/uploads/gallery/${g.image}`)}
//               />
//             </div>
//              {/* OPTIONAL HEADING */}
//             {g.heading && (
//               <p className="p-2 text-center font-semibold bg-gray-100">
//                 {g.heading}
//               </p>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* IMAGE POPUP */}
//       {preview && (
//         <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
//           <img
//             src={preview}
//             className="max-h-[90vh] max-w-[90vw] rounded-xl shadow-2xl"
//           />
//           <button
//             className="absolute top-5 right-5 text-white text-3xl"
//             onClick={() => setPreview(null)}
//           >
//             ✕
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useTranslation } from "react-i18next";

// export default function Gallery() {
//   const { t } = useTranslation();
//   const [gallery, setGallery] = useState([]);

//   useEffect(() => {
//     axios.get("https://luckydraw.hoppersdome.com/api/gallery/all").then((res) => setGallery(res.data));
//   }, []);

//   return (
//     <div className="p-6">
//       <h2 className="text-3xl font-bold mb-6">{t("our_gallery")}</h2>

//       <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//         {gallery.map((g) => (
//           <div key={g.id} className="shadow-lg rounded overflow-hidden relative group">
//             {g.heading && (
//               <p className="p-2 font-semibold text-center bg-gray-200">
//                 {t(g.heading)}
//               </p>
//             )}
//             <img
//               src={`https://luckydraw.hoppersdome.com/uploads/gallery/${g.image}`}
//               className="w-full h-48 object-cover transform transition-transform duration-300 group-hover:scale-105"
//               alt={g.heading || "Gallery Image"}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function Gallery() {
  const { t } = useTranslation();
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    axios
      .get("https://luckydraw.hoppersdome.com/api/gallery/all")
      .then((res) => setGallery(res.data));
  }, []);

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">
          {t("our_gallery")}
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {gallery.map((g) => (
            <div
              key={g.id}
              className="relative overflow-hidden rounded-2xl shadow-lg group hover:shadow-2xl transition-shadow duration-300"
            >
              <img
                src={`https://luckydraw.hoppersdome.com/uploads/gallery/${g.image}`}
                alt={g.heading || "Gallery Image"}
                className="w-full h-48 sm:h-56 md:h-64 object-cover transform transition-transform duration-500 group-hover:scale-105"
              />

              {g.heading && (
                <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white p-2 text-center text-sm sm:text-base font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {t(g.heading)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
